module.exports = __webpack_public_path__ + "static/media/merchant-no-cover.13cfc32f.jpg";